module.exports = __webpack_public_path__ + "static/media/all_devices.d046da60.png";